<h1>Welcome to the LOS Talker configuration Portal</h1>
<div class="page-half">

  <div id="marketing-info">
    <div id="los-info">
      <span>LOS Talker works with several industry-leading Loan Origination Systems</span>
      <ul>

        <li>ICE Technology: Encompass API</li>
        <li>Byte Software:  BytePro API</li>
        <li>Calyx Software: CalyxPoint CSV flat file</li>
        <li>Calyx Software: CalyxPath CSV flat file</li>
        <li>MeridianLink: LendingQB API</li>
        <li>FISERV: PCLender\MortgageDirector API</li>
        <li>OpenClose: OpenClose CSV flat file</li>
        <li>Integra: EPIC API</li>
        <li>Finastra: MortgageBot SQL</li>
        <li>VESTA API</li>
        <li>nCino BOS (SalesForce API)</li>
        <li>LoanVision GL API</li>
        <li>ExperienceCRM API</li>

      </ul>
    </div>
    <div id="links">
      <span>Important links and references</span>
      <ul>
        <li><a href="https://ncinodev.atlassian.net/wiki/spaces/SWIT/overview">Confluence Page</a></li>
      </ul>
    </div>
  </div>
</div>
@if(appComponent.loggedIn){
  <div class="page-half">
    <img class="diagram" src="../../../assets/images/LOS_Talker_for_Technology_Vendor_Client_20251125.jpeg" alt="LOS Talker integration diagram for Technology Vendors and Clients" />
  </div>
}
